import { IPFS_GATEWAY_URL, IPFS_PROTOCOL } from '@/const'

/**
 * IPFS URL을 Gateway URL로 변환하는 메서드
 * cf-ipfs.com을 사용할 때도 사용할 수 있도록 condition을 추가
 * - cf-ipfs.com가 제대로 동작하지 않아 추가됨
 *
 * @param url 변환할 URL
 * @param condition 변환 조건
 * @returns 변환된 URL
 */
export const replaceIPFSUrl = (
  url: string | undefined | null,
  condition: string = IPFS_PROTOCOL,
) => {
  // V2: imageUrl이 없는 경우 빈 문자열 반환
  if (!url) return ''

  return url.startsWith(condition)
    ? url.replace(condition, IPFS_GATEWAY_URL)
    : url
}
